import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error-404',
  templateUrl: './error-404.component.html',
})
export class Error404Component {}
